import { useDefaultLandingPageStore, usePromptStore } from '@globalStore/defaultLandingPageStore';
import getActualShareLink from '@components/common/Sharing/SharingModal/SharingContent/getActualShareLink';
import { setActiveDashboardId } from '@store/dashboards/ui/actions';

export const getStores = () => {
  const defaultLandingPageStore = useDefaultLandingPageStore;
  const promptStore = usePromptStore;
  return { defaultLandingPageStore, promptStore };
};

const onSetDefaultLandingApply = (dispatch, cid, mutateLandingPage) => {
  const { pathname } = window.location;
  dispatch(setActiveDashboardId(null));
  const arr = pathname.split('/');
  const u = getActualShareLink(pathname, cid);

  // Use the mutation to persist to server
  if (mutateLandingPage) {
    mutateLandingPage({
      url: u,
      name: arr[arr.length - 1],
      path: pathname,
    });
  }
};

const onSetDefaultLanding = (dispatch, defaultLandingPage, cid, mutateLandingPage) => {
  const dlpOkFn = () => onSetDefaultLandingApply(dispatch, cid, mutateLandingPage);
  const promptStore = usePromptStore.getState();

  // Single object update for all prompt properties
  promptStore.setPromptState({
    promptNeedInput: dlpNeedInput,
    promptTitle: dlpTitle,
    promptContent: dlpContent(defaultLandingPage),
    promptOkFn: dlpOkFn,
  });

  promptStore.openPrompt();
};

const dlpTitle = 'Make default';
const dlpContentChangeDefault = 'Are you sure you want to change your default dashboard?';
const dlpContentSetDefault = 'Are you sure you want to set your default dashboard?';
const dlpNeedInput = false;

const dlpContent = (defaultLandingPage) => {
  const hasDefaultLandingPage = defaultLandingPage.url.length > 0;
  return hasDefaultLandingPage ? dlpContentChangeDefault : dlpContentSetDefault;
};

export {
  dlpTitle,
  dlpNeedInput,
  dlpContentChangeDefault,
  dlpContentSetDefault,
  onSetDefaultLanding,
  onSetDefaultLandingApply,
  dlpContent,
};
